var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab_menu"},_vm._l((_vm.tabMenuList),function(item,idx){return _c('li',{key:idx,class:_vm.isOn(item.menuLink)},[_c('a',{attrs:{"href":item.menuLink}},[_vm._v(_vm._s(item.menuName))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }